import { useMutation } from '@tanstack/react-query';

import { cancelBnplIntentMutation } from '@/api/booking/cancelBnplIntentMutation';

export const useCancelBnplIntentMutation = () =>
  useMutation(cancelBnplIntentMutation());
